const isProd = import.meta.env.MODE === 'production';

// automatski koristi pravi URL (lokalno ili produkcijski)
export const API_BASE = isProd
  ? 'https://somnia.medico-home.app/api'
  : 'http://localhost:4007/api';

export async function apiFetch(path, options = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) },
    ...options
  });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return await res.json();
}
